// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file pesaje_ganaderia.proto (package sextante.pesaje.ganaderia.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ClienteFincaLoteItem } from "./terceros_lote_pb";
import { file_terceros_lote } from "./terceros_lote_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pesaje_ganaderia.proto.
 */
export const file_pesaje_ganaderia: GenFile = /*@__PURE__*/
  fileDesc("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", [file_terceros_lote]);

/**
 * Compra de animales: un grupo que entra a un lote de la finca.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.CompraAnimalesItem
 */
export type CompraAnimalesItem = Message<"sextante.pesaje.ganaderia.v1.CompraAnimalesItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * Finca de la compra. Viaja en la respuesta porque el guardado no la lleva: el servidor la saca del lote.
   *
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: string lote_entrada_id = 5;
   */
  loteEntradaId: string;

  /**
   * @generated from field: string lote_entrada_nombre = 6;
   */
  loteEntradaNombre: string;

  /**
   * Lote donde estan hoy los animales de la compra, despues de las rotaciones.
   *
   * @generated from field: string lote_actual_id = 7;
   */
  loteActualId: string;

  /**
   * @generated from field: string lote_actual_nombre = 8;
   */
  loteActualNombre: string;

  /**
   * @generated from field: string tipo_animal = 9;
   */
  tipoAnimal: string;

  /**
   * @generated from field: string raza_animal = 10;
   */
  razaAnimal: string;

  /**
   * Numero consecutivo de la compra en la finca, con 5 digitos.
   *
   * @generated from field: string codigo = 11;
   */
  codigo: string;

  /**
   * ISO 8601
   *
   * @generated from field: string fecha_compra = 12;
   */
  fechaCompra: string;

  /**
   * @generated from field: int32 cantidad_animales_compra = 13;
   */
  cantidadAnimalesCompra: number;

  /**
   * Animales comprados que todavia no se vendieron.
   *
   * @generated from field: int32 animales_disponibles = 14;
   */
  animalesDisponibles: number;

  /**
   * Peso promedio por animal al entrar, en kg.
   *
   * @generated from field: double peso_promedio_entrada = 15;
   */
  pesoPromedioEntrada: number;

  /**
   * Peso total al entrar, en kg.
   *
   * @generated from field: double peso_total = 16;
   */
  pesoTotal: number;

  /**
   * @generated from field: double precio_kg = 17;
   */
  precioKg: number;

  /**
   * Peso total por precio por kg.
   *
   * @generated from field: double precio_total = 18;
   */
  precioTotal: number;

  /**
   * Ganancia diaria de peso esperada por animal, en gramos.
   *
   * @generated from field: double gdp_esperado_gr = 19;
   */
  gdpEsperadoGr: number;

  /**
   * Peso por animal con el que se espera venderlo, en kg.
   *
   * @generated from field: double peso_target_salida = 20;
   */
  pesoTargetSalida: number;

  /**
   * Fecha en que se espera llegar al peso de salida, ISO 8601.
   *
   * @generated from field: string fecha_esperada_salida = 21;
   */
  fechaEsperadaSalida: string;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.CompraAnimalesItem.
 * Use `create(CompraAnimalesItemSchema)` to create a new message.
 */
export const CompraAnimalesItemSchema: GenMessage<CompraAnimalesItem> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 0);

/**
 * Pedido de las compras de una finca.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.ListComprasByFincaIdRequest
 */
export type ListComprasByFincaIdRequest = Message<"sextante.pesaje.ganaderia.v1.ListComprasByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.ListComprasByFincaIdRequest.
 * Use `create(ListComprasByFincaIdRequestSchema)` to create a new message.
 */
export const ListComprasByFincaIdRequestSchema: GenMessage<ListComprasByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 1);

/**
 * Compras que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.ListComprasByFincaIdResponse
 */
export type ListComprasByFincaIdResponse = Message<"sextante.pesaje.ganaderia.v1.ListComprasByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem items = 1;
   */
  items: CompraAnimalesItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.ListComprasByFincaIdResponse.
 * Use `create(ListComprasByFincaIdResponseSchema)` to create a new message.
 */
export const ListComprasByFincaIdResponseSchema: GenMessage<ListComprasByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 2);

/**
 * Datos de una compra a crear o editar.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.GuardarCompraRequest
 */
export type GuardarCompraRequest = Message<"sextante.pesaje.ganaderia.v1.GuardarCompraRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string finca_id = 2;
   */
  fincaId: string;

  /**
   * Lote al que entran los animales.
   *
   * @generated from field: string lote_entrada_id = 3;
   */
  loteEntradaId: string;

  /**
   * @generated from field: string raza_animal_id = 4;
   */
  razaAnimalId: string;

  /**
   * Fecha de la compra, ISO 8601.
   *
   * @generated from field: string fecha_compra = 5;
   */
  fechaCompra: string;

  /**
   * @generated from field: int32 cantidad_animales_compra = 6;
   */
  cantidadAnimalesCompra: number;

  /**
   * @generated from field: double peso_promedio_entrada = 7;
   */
  pesoPromedioEntrada: number;

  /**
   * @generated from field: double precio_kg = 8;
   */
  precioKg: number;

  /**
   * @generated from field: double gdp_esperado_gr = 9;
   */
  gdpEsperadoGr: number;

  /**
   * @generated from field: double peso_target_salida = 10;
   */
  pesoTargetSalida: number;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.GuardarCompraRequest.
 * Use `create(GuardarCompraRequestSchema)` to create a new message.
 */
export const GuardarCompraRequestSchema: GenMessage<GuardarCompraRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 3);

/**
 * Resultado de guardar una compra: la compra y lo que el servidor recalculo por ella.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.GuardarCompraResponse
 */
export type GuardarCompraResponse = Message<"sextante.pesaje.ganaderia.v1.GuardarCompraResponse"> & {
  /**
   * @generated from field: sextante.pesaje.ganaderia.v1.CompraAnimalesItem compra = 1;
   */
  compra?: CompraAnimalesItem | undefined;

  /**
   * Lotes recalculados: el de entrada y, si la edicion cambio el lote, tambien el anterior.
   *
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem lotes = 2;
   */
  lotes: ClienteFincaLoteItem[];

  /**
   * Compras de esos lotes, con sus animales disponibles recalculados. Incluye la compra guardada.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem compras = 3;
   */
  compras: CompraAnimalesItem[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.GuardarCompraResponse.
 * Use `create(GuardarCompraResponseSchema)` to create a new message.
 */
export const GuardarCompraResponseSchema: GenMessage<GuardarCompraResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 4);

/**
 * Compra a eliminar.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.EliminarCompraRequest
 */
export type EliminarCompraRequest = Message<"sextante.pesaje.ganaderia.v1.EliminarCompraRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.EliminarCompraRequest.
 * Use `create(EliminarCompraRequestSchema)` to create a new message.
 */
export const EliminarCompraRequestSchema: GenMessage<EliminarCompraRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 5);

/**
 * Resultado de eliminar una compra: lo que el servidor recalculo. Que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.EliminarCompraResponse
 */
export type EliminarCompraResponse = Message<"sextante.pesaje.ganaderia.v1.EliminarCompraResponse"> & {
  /**
   * Lote recalculado: el de entrada de la compra eliminada.
   *
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem lotes = 1;
   */
  lotes: ClienteFincaLoteItem[];

  /**
   * Todas las compras que quedan en la finca, con los codigos renumerados y los animales disponibles
   * recalculados.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem compras = 2;
   */
  compras: CompraAnimalesItem[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.EliminarCompraResponse.
 * Use `create(EliminarCompraResponseSchema)` to create a new message.
 */
export const EliminarCompraResponseSchema: GenMessage<EliminarCompraResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 6);

/**
 * Venta de animales de un lote.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.VentaAnimalesItem
 */
export type VentaAnimalesItem = Message<"sextante.pesaje.ganaderia.v1.VentaAnimalesItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * Finca de la venta. Viaja en la respuesta porque el guardado no la lleva.
   *
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: string lote_salida_id = 5;
   */
  loteSalidaId: string;

  /**
   * @generated from field: string lote_salida_nombre = 6;
   */
  loteSalidaNombre: string;

  /**
   * Numero de la venta en la finca.
   *
   * @generated from field: string codigo = 7;
   */
  codigo: string;

  /**
   * @generated from field: string fecha_venta = 8;
   */
  fechaVenta: string;

  /**
   * @generated from field: int32 cantidad_animales = 9;
   */
  cantidadAnimales: number;

  /**
   * @generated from field: double peso_minimo = 10;
   */
  pesoMinimo: number;

  /**
   * @generated from field: double peso_maximo = 11;
   */
  pesoMaximo: number;

  /**
   * @generated from field: double peso_promedio = 12;
   */
  pesoPromedio: number;

  /**
   * @generated from field: double peso_total = 13;
   */
  pesoTotal: number;

  /**
   * Peso de cada animal vendido, en kg.
   *
   * @generated from field: repeated double pesos_animales = 14;
   */
  pesosAnimales: number[];

  /**
   * Precio por kg.
   *
   * @generated from field: double precio_kilo = 15;
   */
  precioKilo: number;

  /**
   * @generated from field: double precio_total = 16;
   */
  precioTotal: number;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.VentaAnimalesItem.
 * Use `create(VentaAnimalesItemSchema)` to create a new message.
 */
export const VentaAnimalesItemSchema: GenMessage<VentaAnimalesItem> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 7);

/**
 * Pedido de las ventas de una finca.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.ListVentasByFincaIdRequest
 */
export type ListVentasByFincaIdRequest = Message<"sextante.pesaje.ganaderia.v1.ListVentasByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.ListVentasByFincaIdRequest.
 * Use `create(ListVentasByFincaIdRequestSchema)` to create a new message.
 */
export const ListVentasByFincaIdRequestSchema: GenMessage<ListVentasByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 8);

/**
 * Ventas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.ListVentasByFincaIdResponse
 */
export type ListVentasByFincaIdResponse = Message<"sextante.pesaje.ganaderia.v1.ListVentasByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.VentaAnimalesItem items = 1;
   */
  items: VentaAnimalesItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.ListVentasByFincaIdResponse.
 * Use `create(ListVentasByFincaIdResponseSchema)` to create a new message.
 */
export const ListVentasByFincaIdResponseSchema: GenMessage<ListVentasByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 9);

/**
 * Datos de una venta a crear o editar.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.GuardarVentaRequest
 */
export type GuardarVentaRequest = Message<"sextante.pesaje.ganaderia.v1.GuardarVentaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string lote_salida_id = 2;
   */
  loteSalidaId: string;

  /**
   * @generated from field: string fecha_venta = 3;
   */
  fechaVenta: string;

  /**
   * @generated from field: double precio_kilo = 4;
   */
  precioKilo: number;

  /**
   * Peso de cada animal vendido, en kg. La cantidad de animales es la cantidad de pesos.
   *
   * @generated from field: repeated double pesos_animales = 5;
   */
  pesosAnimales: number[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.GuardarVentaRequest.
 * Use `create(GuardarVentaRequestSchema)` to create a new message.
 */
export const GuardarVentaRequestSchema: GenMessage<GuardarVentaRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 10);

/**
 * Resultado de guardar una venta: la venta y lo que el servidor recalculo por ella.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.GuardarVentaResponse
 */
export type GuardarVentaResponse = Message<"sextante.pesaje.ganaderia.v1.GuardarVentaResponse"> & {
  /**
   * @generated from field: sextante.pesaje.ganaderia.v1.VentaAnimalesItem venta = 1;
   */
  venta?: VentaAnimalesItem | undefined;

  /**
   * Lotes recalculados: el de salida y, si la edicion cambio el lote, tambien el anterior.
   *
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem lotes = 2;
   */
  lotes: ClienteFincaLoteItem[];

  /**
   * Compras de esos lotes, con sus animales disponibles recalculados.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem compras = 3;
   */
  compras: CompraAnimalesItem[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.GuardarVentaResponse.
 * Use `create(GuardarVentaResponseSchema)` to create a new message.
 */
export const GuardarVentaResponseSchema: GenMessage<GuardarVentaResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 11);

/**
 * Venta a eliminar.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.EliminarVentaRequest
 */
export type EliminarVentaRequest = Message<"sextante.pesaje.ganaderia.v1.EliminarVentaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.EliminarVentaRequest.
 * Use `create(EliminarVentaRequestSchema)` to create a new message.
 */
export const EliminarVentaRequestSchema: GenMessage<EliminarVentaRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 12);

/**
 * Resultado de eliminar una venta: lo que el servidor recalculo. Que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.EliminarVentaResponse
 */
export type EliminarVentaResponse = Message<"sextante.pesaje.ganaderia.v1.EliminarVentaResponse"> & {
  /**
   * Lote recalculado: el de salida de la venta eliminada.
   *
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem lotes = 1;
   */
  lotes: ClienteFincaLoteItem[];

  /**
   * Compras de ese lote, con sus animales disponibles recalculados.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem compras = 2;
   */
  compras: CompraAnimalesItem[];

  /**
   * Todas las ventas que quedan en la finca, con los codigos renumerados.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.VentaAnimalesItem ventas = 3;
   */
  ventas: VentaAnimalesItem[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.EliminarVentaResponse.
 * Use `create(EliminarVentaResponseSchema)` to create a new message.
 */
export const EliminarVentaResponseSchema: GenMessage<EliminarVentaResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 13);

/**
 * Evento de rotacion, pesaje o veterinaria de un lote.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaItem
 */
export type RotacionPesajeVeterinariaItem = Message<"sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * Finca del evento. Viaja en la respuesta porque el guardado no la lleva.
   *
   * @generated from field: string finca_id = 4;
   */
  fincaId: string;

  /**
   * @generated from field: string lote_origen_id = 5;
   */
  loteOrigenId: string;

  /**
   * @generated from field: string lote_origen_nombre = 6;
   */
  loteOrigenNombre: string;

  /**
   * Lote al que se movieron los animales. Solo si is_rotacion.
   *
   * @generated from field: optional string lote_destino_id = 7;
   */
  loteDestinoId?: string | undefined;

  /**
   * @generated from field: optional string lote_destino_nombre = 8;
   */
  loteDestinoNombre?: string | undefined;

  /**
   * @generated from field: string fecha = 9;
   */
  fecha: string;

  /**
   * @generated from field: int32 cantidad_animales = 10;
   */
  cantidadAnimales: number;

  /**
   * El evento mueve animales del lote origen al destino.
   *
   * @generated from field: bool is_rotacion = 11;
   */
  isRotacion: boolean;

  /**
   * El evento registra el peso de los animales.
   *
   * @generated from field: bool is_pesaje = 12;
   */
  isPesaje: boolean;

  /**
   * El evento registra procedimientos veterinarios.
   *
   * @generated from field: bool is_veterinaria = 13;
   */
  isVeterinaria: boolean;

  /**
   * @generated from field: double peso_total = 14;
   */
  pesoTotal: number;

  /**
   * @generated from field: optional double peso_promedio = 15;
   */
  pesoPromedio?: number | undefined;

  /**
   * @generated from field: optional double peso_minimo = 16;
   */
  pesoMinimo?: number | undefined;

  /**
   * @generated from field: optional double peso_maximo = 17;
   */
  pesoMaximo?: number | undefined;

  /**
   * Peso de cada animal pesado, en kg.
   *
   * @generated from field: repeated double pesos_animales = 18;
   */
  pesosAnimales: number[];

  /**
   * @generated from field: optional string vet_observaciones = 19;
   */
  vetObservaciones?: string | undefined;

  /**
   * Procedimientos veterinarios aplicados.
   *
   * @generated from field: repeated string procedimiento_ids = 20;
   */
  procedimientoIds: string[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaItem.
 * Use `create(RotacionPesajeVeterinariaItemSchema)` to create a new message.
 */
export const RotacionPesajeVeterinariaItemSchema: GenMessage<RotacionPesajeVeterinariaItem> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 14);

/**
 * Pedido de los eventos de una finca.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.ListRotacionesByFincaIdRequest
 */
export type ListRotacionesByFincaIdRequest = Message<"sextante.pesaje.ganaderia.v1.ListRotacionesByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.ListRotacionesByFincaIdRequest.
 * Use `create(ListRotacionesByFincaIdRequestSchema)` to create a new message.
 */
export const ListRotacionesByFincaIdRequestSchema: GenMessage<ListRotacionesByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 15);

/**
 * Eventos que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.ListRotacionesByFincaIdResponse
 */
export type ListRotacionesByFincaIdResponse = Message<"sextante.pesaje.ganaderia.v1.ListRotacionesByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaItem items = 1;
   */
  items: RotacionPesajeVeterinariaItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.ListRotacionesByFincaIdResponse.
 * Use `create(ListRotacionesByFincaIdResponseSchema)` to create a new message.
 */
export const ListRotacionesByFincaIdResponseSchema: GenMessage<ListRotacionesByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 16);

/**
 * Datos de un evento a crear o editar. Puede combinar rotacion, pesaje y veterinaria.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.GuardarRotacionRequest
 */
export type GuardarRotacionRequest = Message<"sextante.pesaje.ganaderia.v1.GuardarRotacionRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string lote_origen_id = 2;
   */
  loteOrigenId: string;

  /**
   * @generated from field: optional string lote_destino_id = 3;
   */
  loteDestinoId?: string | undefined;

  /**
   * @generated from field: string fecha = 4;
   */
  fecha: string;

  /**
   * @generated from field: int32 cantidad_animales = 5;
   */
  cantidadAnimales: number;

  /**
   * @generated from field: bool is_rotacion = 6;
   */
  isRotacion: boolean;

  /**
   * @generated from field: bool is_pesaje = 7;
   */
  isPesaje: boolean;

  /**
   * @generated from field: bool is_veterinaria = 8;
   */
  isVeterinaria: boolean;

  /**
   * @generated from field: repeated double pesos_animales = 9;
   */
  pesosAnimales: number[];

  /**
   * @generated from field: repeated string procedimiento_ids = 10;
   */
  procedimientoIds: string[];

  /**
   * @generated from field: optional string vet_observaciones = 11;
   */
  vetObservaciones?: string | undefined;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.GuardarRotacionRequest.
 * Use `create(GuardarRotacionRequestSchema)` to create a new message.
 */
export const GuardarRotacionRequestSchema: GenMessage<GuardarRotacionRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 17);

/**
 * Resultado de guardar un evento: el evento y lo que el servidor recalculo por el.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.GuardarRotacionResponse
 */
export type GuardarRotacionResponse = Message<"sextante.pesaje.ganaderia.v1.GuardarRotacionResponse"> & {
  /**
   * @generated from field: sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaItem evento = 1;
   */
  evento?: RotacionPesajeVeterinariaItem | undefined;

  /**
   * Lotes recalculados: el de origen y, si es rotacion, el de destino. Si la edicion cambio el destino,
   * tambien el destino anterior.
   *
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem lotes = 2;
   */
  lotes: ClienteFincaLoteItem[];

  /**
   * Compras de esos lotes, con sus animales disponibles recalculados.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem compras = 3;
   */
  compras: CompraAnimalesItem[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.GuardarRotacionResponse.
 * Use `create(GuardarRotacionResponseSchema)` to create a new message.
 */
export const GuardarRotacionResponseSchema: GenMessage<GuardarRotacionResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 18);

/**
 * Evento a eliminar.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.EliminarRotacionRequest
 */
export type EliminarRotacionRequest = Message<"sextante.pesaje.ganaderia.v1.EliminarRotacionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.EliminarRotacionRequest.
 * Use `create(EliminarRotacionRequestSchema)` to create a new message.
 */
export const EliminarRotacionRequestSchema: GenMessage<EliminarRotacionRequest> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 19);

/**
 * Resultado de eliminar un evento: lo que el servidor recalculo. Que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.pesaje.ganaderia.v1.EliminarRotacionResponse
 */
export type EliminarRotacionResponse = Message<"sextante.pesaje.ganaderia.v1.EliminarRotacionResponse"> & {
  /**
   * Lotes recalculados: el de origen y, si era rotacion, el de destino.
   *
   * @generated from field: repeated sextante.terceros.lote.v1.ClienteFincaLoteItem lotes = 1;
   */
  lotes: ClienteFincaLoteItem[];

  /**
   * Compras de esos lotes, con sus animales disponibles recalculados.
   *
   * @generated from field: repeated sextante.pesaje.ganaderia.v1.CompraAnimalesItem compras = 2;
   */
  compras: CompraAnimalesItem[];
};

/**
 * Describes the message sextante.pesaje.ganaderia.v1.EliminarRotacionResponse.
 * Use `create(EliminarRotacionResponseSchema)` to create a new message.
 */
export const EliminarRotacionResponseSchema: GenMessage<EliminarRotacionResponse> = /*@__PURE__*/
  messageDesc(file_pesaje_ganaderia, 20);

/**
 * Pesaje de ganaderia de la SPA Cliente: compras, ventas y eventos de rotacion, pesaje y veterinaria.
 * Logica propia del servicio gRPC, sin la capa vieja de servicios. Cada guardado o baja recalcula el
 * inventario de los lotes afectados. Los 3 son finca-scoped, con el mismo shape (listado con delta +
 * guardado crear-o-actualizar + baja), agrupados en un solo proto como catalogos_pesaje.proto ya
 * agrupa TipoAnimal/RazaAnimal/ProcedimientoVeterinario. Requiere sesion.
 * 
 * Respuestas de guardar y eliminar (2026-10-08): ademas del registro traen lo que el servidor cambio por el
 * movimiento, ya recalculado: los lotes afectados, las compras de esos lotes (cambian sus animales
 * disponibles) y, al eliminar una compra o una venta, todas las de la finca (se renumeran sus codigos). La
 * app lo escribe en su base local al momento y no depende de volver a pedir los listados. Antes la app
 * solo marcaba los listados para pedirlos despues, y el mapa podia quedar con los datos de antes del
 * movimiento hasta recargar la pagina.
 * 
 * Nombres de mensaje con prefijo de dominio: ver terceros_lote.proto para el gotcha real del
 * csharp_namespace compartido — revisar que un nombre no exista ya en otro .proto antes de usarlo.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.pesaje.ganaderia.v1.CompraAnimalesService
 */
export const CompraAnimalesService: GenService<{
  /**
   * Compras de una finca, por delta.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.CompraAnimalesService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListComprasByFincaIdRequestSchema;
    output: typeof ListComprasByFincaIdResponseSchema;
  },
  /**
   * Crea la compra si no viene id, o la actualiza si viene. Calcula peso y precio totales, el codigo y la
   * fecha esperada de salida. Devuelve tambien los lotes y las compras que recalculo.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.CompraAnimalesService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarCompraRequestSchema;
    output: typeof GuardarCompraResponseSchema;
  },
  /**
   * Elimina una compra y renumera los codigos de las que quedan en la finca. Devuelve el lote recalculado y
   * las compras que quedan.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.CompraAnimalesService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarCompraRequestSchema;
    output: typeof EliminarCompraResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pesaje_ganaderia, 0);

/**
 * Ventas de animales de un lote.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.pesaje.ganaderia.v1.VentaAnimalesService
 */
export const VentaAnimalesService: GenService<{
  /**
   * Ventas de una finca, por delta.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.VentaAnimalesService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListVentasByFincaIdRequestSchema;
    output: typeof ListVentasByFincaIdResponseSchema;
  },
  /**
   * Crea la venta si no viene id, o la actualiza si viene. Calcula los pesos y el precio total a partir de
   * los pesos de cada animal. Devuelve tambien los lotes y las compras que recalculo.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.VentaAnimalesService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarVentaRequestSchema;
    output: typeof GuardarVentaResponseSchema;
  },
  /**
   * Elimina una venta y renumera los codigos de las que quedan en la finca. Devuelve el lote y las compras
   * que recalculo, y las ventas que quedan.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.VentaAnimalesService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarVentaRequestSchema;
    output: typeof EliminarVentaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pesaje_ganaderia, 1);

/**
 * Eventos de un lote: mover animales a otro lote, pesarlos o registrar procedimientos veterinarios.
 * 
 * Pertenencia (2026-09-30): solo trabaja con datos de fincas del cliente de la sesion. Una finca, lote o
 * registro de otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaService
 */
export const RotacionPesajeVeterinariaService: GenService<{
  /**
   * Eventos de una finca, por delta.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListRotacionesByFincaIdRequestSchema;
    output: typeof ListRotacionesByFincaIdResponseSchema;
  },
  /**
   * Crea el evento si no viene id, o lo actualiza si viene. Devuelve tambien los lotes y las compras que
   * recalculo.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarRotacionRequestSchema;
    output: typeof GuardarRotacionResponseSchema;
  },
  /**
   * Elimina un evento. Devuelve los lotes y las compras que recalculo.
   *
   * @generated from rpc sextante.pesaje.ganaderia.v1.RotacionPesajeVeterinariaService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarRotacionRequestSchema;
    output: typeof EliminarRotacionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_pesaje_ganaderia, 2);

